import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import queryClient from "hooks/queryClient";
import App from "app/App";
import AppToastContainer from "components/AppToastContainer/AppToastContainer";
import CommonErrorBoundary from "app/layout/CommonErrorBoundary/CommonErrorBoundary";
import { MetricsProvider } from "metrics/MetricsContext";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <CommonErrorBoundary>
        <QueryClientProvider client={queryClient}>
            <MetricsProvider>
                <BrowserRouter basename={baseUrl}>
                    <App />
                    <AppToastContainer />
                </BrowserRouter>
            </MetricsProvider>
            <ReactQueryDevtools />
        </QueryClientProvider>
    </CommonErrorBoundary>,
);
